import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import i18n from 'portal-base/src/decorators/i18n';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import { isIOS } from '../../services/device';
import nls from '../../locales/indexes.nls';
import style from './ki-ds-pwa-install-prompt.css';

const CLASS_NAME = 'ki-ds-pwa-install-prompt';

@i18n(nls)
@customElement(CLASS_NAME)
export class KiDsPwaInstallPrompt extends KiDsPwaComponent {
    static styles = style;

    _className = CLASS_NAME;

    static get properties() {
        return {
            deferredPrompt: { type: Object },
            _showIosDialog: { type: Boolean, state: true },
        };
    }

    constructor() {
        super();
        this.deferredPrompt = null;
        this._showIosDialog = false;
    }

    async _install() {
        if (isIOS()) {
            this._showIosDialog = true;
            return;
        }
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            const { outcome } = await this.deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                this.dispatchEvent(new CustomEvent('install-accepted', { bubbles: true, composed: true }));
            }
        }
    }

    _dismiss() {
        this.dispatchEvent(new CustomEvent('install-dismissed', { bubbles: true, composed: true }));
    }

    _closeIosDialog() {
        this._showIosDialog = false;
    }

    render() {
        return html`
            ${this._renderBanner()}
            ${this._showIosDialog ? this._renderIosDialog() : nothing}
        `;
    }

    _renderBanner() {
        return html`
            <div class="install">
                <div class="install__meta">
                    <img src="./assets/icon-192x192.png" alt="" />
                    <div>
                        <div>datasphere</div>
                        <div class="secondary__headline">${this._getLabel('installSubtitle')}</div>
                    </div>
                </div>
                <div class="install__functions">
                    <div @click=${this._install}>${this._getLabel('installButton')}</div>
                    <span @click=${this._dismiss}>
                        <i class="fa-sharp fa-solid fa-xmark"></i>
                    </span>
                </div>
            </div>
        `;
    }

    _renderIosDialog() {
        return html`
            <div class="dialogblur">
                <div class="iosdialog">
                    <div class="iosdialog__header">
                        <div class="header__left">
                            <img src="./assets/icon-192x192.png" alt="" />
                            <span>${this._getLabel('installIosTitle')}</span>
                        </div>
                        <div @click=${this._closeIosDialog}>
                            <i class="fa-sharp fa-solid fa-xmark"></i>
                        </div>
                    </div>
                    <div class="iosdialog__body">
                        ${this._getLabel('installIosBody')}
                        <ol>
                            <li>
                                ${this._getLabel('installIosTapOn')}
                                <span class="iosdialog__markedtext">
                                    <i class="fa-sharp fa-solid fa-arrow-up-from-bracket"></i>
                                </span>
                            </li>
                            <li>
                                <span class="iosdialog__markedtext">
                                    ${this._getLabel('installIosAddToHome')}
                                </span>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        `;
    }
}
